import { render, staticRenderFns } from "./studentbzr.vue?vue&type=template&id=b8a353a8&scoped=true&"
import script from "./studentbzr.vue?vue&type=script&lang=js&"
export * from "./studentbzr.vue?vue&type=script&lang=js&"
import style0 from "./studentbzr.vue?vue&type=style&index=0&id=b8a353a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a353a8",
  null
  
)

export default component.exports